import React, { useState } from 'react';
import { isTablet } from 'react-device-detect';
import './MobilePopup.css';

const MobilePopup = () => {
  // Show only on mobile phones (≤ 767px), not on tablets/tabs (≥ 768px or tablet devices)
  const [visible, setVisible] = useState(() => {
    if (isTablet) return false;
    return window.matchMedia('(max-width: 767px)').matches;
  });

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="mob-popup-overlay">
      <div className="mob-popup-card">
        {/* Laptop icon */}
        <div className="mob-popup-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            width="64"
            height="64"
            aria-hidden="true"
          >
            {/* Screen */}
            <rect x="8" y="8" width="48" height="32" rx="3" ry="3" fill="#5a7fa8" />
            <rect x="11" y="11" width="42" height="26" rx="1" ry="1" fill="#c8ddf0" />
            {/* Hinge */}
            <rect x="10" y="40" width="44" height="4" rx="2" ry="2" fill="#4a6f96" />
            {/* Base */}
            <rect x="4" y="44" width="56" height="6" rx="3" ry="3" fill="#5a7fa8" />
            {/* Touchpad */}
            <rect x="26" y="46" width="12" height="2" rx="1" ry="1" fill="#4a6f96" />
          </svg>
        </div>

        <h2 className="mob-popup-title">Desktop Recommended</h2>

        <p className="mob-popup-body">
          This website works best on a <strong>Desktop</strong> or <strong>Laptop</strong> for smooth navigation and full functionality.
        </p>

        <button
          id="mobilePopupCloseBtn"
          className="mob-popup-btn"
          onClick={handleClose}
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default MobilePopup;
